import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchTable } from '../helpers/sagaHelpers';

function* watchFetchTable() {
  yield takeLatest('regions/fetchTable', fetchTable);
}

export default function* rootSaga() {
  yield all([fork(watchFetchTable)]);
}
